export const validationErrorTranslationMap = {
  ticketType: 'complaintForm.ticket.validation.label.ticket_type',
  customerNo: 'complaintForm.ticket.customer_number',
  company: 'complaintForm.ticket.customer_number',
  address: 'complaintForm.ticket.validation.label.address',
  zip: 'form.zip',
  city: 'form.city',
  contactPersonSurname: 'complaintForm.ticket.contact_person_surname',
  contactPersonName: 'complaintForm.ticket.contact_person_name',
  phone: 'complaintForm.ticket.phone',
  email: 'complaintForm.ticket.email',
  privacy: 'complaintForm.ticket.validation.label.privacy',
  acceptTerms: 'complaintForm.ticket.validation.label.acceptTerms',
  brand: 'complaintForm.ticket.validation.label.brand',
  engineSerialNo: 'complaintForm.ticket.engine.engine_series_no',
  modelType: 'complaintForm.ticket.engine.engine_type',
  mileage: 'complaintForm.ticket.engine.mileage_in_km',
  damage: 'complaintForm.ticket.battery.damage',
  description: 'complaintForm.claim.description',
  errorFrequency: 'complaintForm.ticket.engine.error_rate',
}

export default {
  validationErrorTranslationMap,
}
